import {takeLatest} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function* () {
	yield takeLatest(ACTION.UPDATE_STATUS_INVENTORY.REQUEST, saga.updateStatusInventoryRequest);
	yield takeLatest(ACTION.UPDATE_STATUS_INVENTORY.SUCCESS, saga.updateStatusInventorySuccess);
	yield takeLatest(ACTION.UPDATE_STATUS_INVENTORY.FAILED, saga.updateStatusInventoryFailed);
}
